module.exports = __webpack_public_path__ + "img/SurveillanceDormitory105Alive.92de1c28.gif";